import React from 'react';
import { AppContainer } from 'react-hot-loader';
import { render } from 'react-dom';
import configStore from './common/configStore';
import routeConfig from './common/routeConfig';
import Root from './Root';
import {localStore} from 'src-common/utils';
import generateUUID from 'src-common/uuid';
import _ from 'lodash'

let initLocalStore = localStore.getStore('interact_data')
let uid = localStore.getStore('uid')
if (_.isEmpty(initLocalStore)) {
  localStore.setStore('interact_data', {"interact_data": {
    "influencer_id_list": [],
    "street_id_list": [],
    "product_id_list": []
  }})
}
if (!uid) {
  localStore.setStore('uid',{"uid": generateUUID()})
}

const store = configStore();

function renderApp(app) {
  render(
    <AppContainer>
      {app}
    </AppContainer>,
    document.getElementById('root')
  );
}

renderApp(<Root store={store} routeConfig={routeConfig} />);

// Hot Module Replacement API
/* istanbul ignore if  */
if (module.hot) {
  module.hot.accept('./common/routeConfig', () => {
    const nextRouteConfig = require('./common/routeConfig').default; // eslint-disable-line
    renderApp(<Root store={store} routeConfig={nextRouteConfig} />);
  });
  module.hot.accept('./Root', () => {
    const nextRoot = require('./Root').default; // eslint-disable-line
    renderApp(<Root store={store} routeConfig={routeConfig} />);
  });
}



// WEBPACK FOOTER //
// ./src/index.js